import React from 'react';
import { CheckCircle, Circle, Trophy } from 'lucide-react';

const MilestoneTracker = ({ goals }) => {
  const allMilestones = goals?.flatMap(goal => 
    (goal?.milestones || [])?.map(milestone => ({
      ...milestone,
      goalTitle: goal?.goal_type,
      goalId: goal?.id
    }))
  );

  const sortedMilestones = allMilestones?.sort((a, b) => 
    a?.milestone_value - b?.milestone_value
  );

  return (
    <div className="bg-white rounded-xl shadow-lg p-6">
      <div className="flex items-center gap-3 mb-6">
        <Trophy className="w-6 h-6 text-yellow-500" />
        <h2 className="text-2xl font-bold text-gray-900">Milestone Progress</h2>
      </div>
      {sortedMilestones?.length === 0 ? (
        <p className="text-gray-500 text-center py-8">
          No milestones yet. Create a goal to start tracking milestones!
        </p>
      ) : (
        <div className="space-y-4">
          {sortedMilestones?.map((milestone, index) => (
            <div
              key={milestone?.id}
              className={`flex items-start gap-4 p-4 rounded-lg border-2 ${
                milestone?.is_achieved
                  ? 'bg-green-50 border-green-200' :'bg-gray-50 border-gray-200'
              }`}
            >
              <div className="flex-shrink-0">
                {milestone?.is_achieved ? (
                  <CheckCircle className="w-6 h-6 text-green-600" />
                ) : (
                  <Circle className="w-6 h-6 text-gray-400" />
                )}
              </div>
              
              <div className="flex-1 min-w-0">
                <h3 className="font-semibold text-gray-900 mb-1">
                  {milestone?.milestone_name}
                </h3>
                <p className="text-sm text-gray-600 mb-2">
                  Target: {milestone?.milestone_value}
                  {milestone?.goalTitle !== 'weekly_practice' && '%'}
                </p>
                {milestone?.is_achieved && milestone?.achieved_at && (
                  <p className="text-xs text-green-600">
                    ✓ Achieved on {new Date(milestone.achieved_at)?.toLocaleDateString()}
                  </p>
                )}
                {milestone?.badge_earned && (
                  <div className="inline-block bg-yellow-100 text-yellow-700 px-3 py-1 rounded-full text-xs font-semibold mt-2">
                    🏆 {milestone?.badge_earned}
                  </div>
                )}
              </div>

              <div className="flex-shrink-0">
                <span className={`text-xs font-semibold px-2 py-1 rounded ${
                  milestone?.is_achieved
                    ? 'bg-green-200 text-green-800' :'bg-gray-200 text-gray-600'
                }`}>
                  {milestone?.is_achieved ? 'Completed' : 'In Progress'}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MilestoneTracker;